// hooks
import { useQuery } from 'react-query';
import { getDefinitionsCount } from 'RestAPIs/tasks/definitions';

const useGetDefinitionsCount = (
  { costCenterIds }: { costCenterIds: string },
  options: Record<string, any> = {}
) => {
  return useQuery(
    ['quality-monitor-def-count', costCenterIds],
    async () => {
      const { data } = await getDefinitionsCount({ costCenterIds });
      return data;
    },
    { ...options }
  );
};

export default useGetDefinitionsCount;
